import { LoadingOutlined } from '@ant-design/icons'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { useDirectiveContext } from '@components/Reports/DispatchDirective/DirectiveContext'
import { handleAllocationsSave, handleConstraintsSave } from '@components/Reports/DispatchDirective/util'
import { addCommasToNumber, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import moment from 'moment'
import React, { useState } from 'react'

import { ClickTextEdit } from './ClickTextEdit'

export function DailyRow({ directive, updateRow, setIsExpanded }) {
  const { selectedDate } = useDirectiveContext()
  const [isRefreshing, setIsRefreshing] = useState(false)
  const { scopes } = useSecurityContext()

  const canEditDirectives =
    scopes.supply_directive.supply_view.edit && moment(selectedDate).isAfter(moment().startOf('day'))

  const onSave = (e) =>
    handleAllocationsSave(e.target.value, directive, 'daily_percent', updateRow, setIsRefreshing, setIsExpanded)
  const onConstraintsSave = (e) =>
    handleConstraintsSave(
      e.target.value,
      directive,
      e.target.name,
      selectedDate,
      updateRow,
      setIsRefreshing,
      setIsExpanded
    )

  return (
    <Horizontal height={30}>
      <Vertical flex={1}>
        <Horizontal>
          <Vertical flex={1}>
            {isRefreshing ? (
              <Texto weight={600} className='flex' align='right' appearance='secondary'>
                <LoadingOutlined className='mr-2' /> Refreshing
              </Texto>
            ) : (
              <Texto weight={500} align='right' category='h6'>
                {addCommasToNumber(directive.daily_allocation, 0)}
              </Texto>
            )}
          </Vertical>

          <Vertical flex={1}>
            {canEditDirectives ? (
              <ClickTextEdit
                display={
                  <Texto weight={500} align='right' category='h6' className='pr-2'>
                    {addCommasToNumber(directive.daily_percent * 100, 0)}%
                  </Texto>
                }
                onSave={onSave}
                defaultValue={addCommasToNumber(directive.daily_percent * 100, 0)}
              />
            ) : (
              <Texto weight={500} align='right' category='h6' className='pr-2'>
                {`${directive.daily_percent.toLocaleString('en') * 100}%`}
              </Texto>
            )}
          </Vertical>

          <Vertical className='pr-4' flex={1}>
            <Texto weight={500} align='right' category='h6'>
              {addCommasToNumber(directive.daily_start_allocation, 0)}
            </Texto>
          </Vertical>
        </Horizontal>
      </Vertical>

      <Horizontal flex={1}>
        <Vertical>
          <Horizontal>
            {canEditDirectives ? (
              <Horizontal className='flex' flex={1}>
                <ClickTextEdit
                  onSave={onConstraintsSave}
                  defaultValue={addCommasToNumber(directive.directive_min)}
                  value={directive.directive_min}
                  display={<Texto category='h6'>{addCommasToNumber(directive.directive_min)}</Texto>}
                  placeholder='Min'
                  name='min'
                />
                <ClickTextEdit
                  onSave={onConstraintsSave}
                  defaultValue={addCommasToNumber(directive.directive_max)}
                  value={directive.directive_max}
                  display={<Texto category='h6'>{addCommasToNumber(directive.directive_max)}</Texto>}
                  placeholder='Max'
                  name='max'
                />
              </Horizontal>
            ) : (
              <Horizontal justifyContent='space-around' flex={1}>
                <Texto category='h6'>{addCommasToNumber(directive.directive_min)}</Texto>
                <Texto category='h6'>{addCommasToNumber(directive.directive_max)}</Texto>
              </Horizontal>
            )}
          </Horizontal>
        </Vertical>
      </Horizontal>
    </Horizontal>
  )
}
